if (!customElements.get('mobile-nav-bar')) {
  class MobileNavBar extends HTMLElement {
    connectedCallback() {
      this.cartItem = this.querySelector('[data-mobile-nav-cart]');
      this.badge = this.querySelector('[data-cart-count]');

      if (this.cartItem) {
        this._onCartUpdate = this._onCartUpdate.bind(this);

        if (window.PubSub) {
          this._cartSubscription = PubSub.subscribe(
            PubSub.eventName || 'cart:change',
            this._onCartUpdate
          );
        }

        document.addEventListener('cart:change', this._onCartUpdate);
      }
    }

    disconnectedCallback() {
      if (this._cartSubscription && window.PubSub) {
        PubSub.unsubscribe(this._cartSubscription);
        this._cartSubscription = null;
      }

      document.removeEventListener('cart:change', this._onCartUpdate);
    }

    _onCartUpdate(event) {
      let count = 0;

      if (event && event.detail && event.detail.cart) {
        count = event.detail.cart.item_count || 0;
      } else if (event && event.cart) {
        count = event.cart.item_count || 0;
      }

      this._updateBadge(count);
    }

    _updateBadge(count) {
      if (!this.cartItem) return;

      let badge = this.cartItem.querySelector('[data-cart-count]');

      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'mobile-nav-bar__badge';
          badge.setAttribute('data-cart-count', '');
          this.cartItem.querySelector('.mobile-nav-bar__icon').appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }

      this.badge = this.cartItem.querySelector('[data-cart-count]');
    }
  }

  customElements.define('mobile-nav-bar', MobileNavBar);
}
